export interface RouteParams {
  phrase?: string | string[]
  city: string
  tag: string
  province: string
  url?: string
  village?: string
}

export const filtersQueryParams = {
  checkin: undefined,
  checkout: undefined,
  guests: undefined,
  instant: undefined,
  national: undefined,
  max_price: undefined,
  min_price: undefined,
  villa: undefined,
  apartment: undefined,
  boomgardi: undefined,
  cottage: undefined,
  guarantee: undefined,

  // more filters
  bed_count: undefined,
  bedroom_count: undefined,
  is_mehman_navaz: undefined,
  long_term_discount: undefined,
  rule_ceremony: undefined,
  twenty_four_hour: undefined,
  rule_pets: undefined,
  'suitable-for-elderly-and-children': undefined,
  detached: undefined,
  private_yard: undefined,
  pool: undefined,
  barbecue: undefined,
  wifi: undefined,
  'billiard-pool': undefined,
  jacuzzi: undefined,
  suna: undefined,
  forest: undefined,
  mountain: undefined,
  desert: undefined,
  coastal: undefined,
  in_town: undefined,
  bathroom: undefined,
  heating: undefined,
  water_cooling: undefined,
  split_cooling: undefined,
  parking: undefined,
  indoor_pool: undefined,
  outdoor_pool: undefined,
  warm_water_pool: undefined,
  toilet: undefined,
  balcony: undefined,
  elevator: undefined,
  furniture: undefined,
  kitchen_equipments: undefined,
  tv: undefined,
  receiver: undefined,
  breakfast: undefined,

  // other
  page: undefined,
  sortBy: undefined,
  late_night: undefined,
  tag: undefined,
  co_ordinates: undefined,
  'is_descending[recent_rank]': undefined,
  phrase: undefined,
  parent_id: undefined,
  near_cities: undefined,
  place_id: undefined,
  placeCordinates: undefined,
  host_uid: undefined,
}

export const tags = [
  'یلدا',
  'ویژه_نوروز_97',
  'ویژه_زمستان',
  'ویژه_پاییز',
  'نوبرانه',
  'مجلل',
  'مجتمع',
  'کلبه26303',
  'کلبه',
  'فیلبند',
  'طبیعت-و-استراحت',
  'سفر-شغلی',
  'سفر-دسته-جمعی',
  'سالاد_فصل',
  'روستایی',
  'خنک',
  'جشن-و-تولد',
  'تستی',
  'تست',
  'تجربه_جدید',
  'پیشنهاد_ویژه',
  'پیشنهاد-ویژه',
  'پیشنهاد_ویژ',
  'پرطرفدارترین',
  'بومگردی',
  'اقتصادی',
  'اطراف_مشهد',
  'اطراف_شیراز',
  'اطراف-تهران',
  'اطراف_تهران',
  'اطراف_اصفهان',
  'اجاره ویلا ییلاقی',
  'اجاره ویلا مبله',
  'اجاره ویلا کویری',
  'اجاره ویلا کوهستانی',
  'اجاره ویلا شهری',
  'اجاره ویلا ساحلی',
  'اجاره ویلا روستایی',
  'اجاره ویلا دوبلکس',
  'اجاره ویلا دربستی',
  'اجاره ویلا دربست',
  'اجاره ویلا در شمال',
  'اجاره ویلا داخل شهرک',
  'اجاره ویلا حیاط دار',
  'اجاره ویلا جنگلی',
  'اجاره ویلا جکوزی دار',
  'اجاره ویلا تاریخی',
  'اجاره ویلا با استخر سر پوشیده',
  'اجاره ویلا با استخر روباز',
  'اجاره ویلا با استخر',
  'اجاره ویلا استخر دار',
  'آخر_هفته',
  '56246',
  'روستایی,کلبه,بومگردی',
  'جشن و تولد',
  'سفر دسته جمعی',
  'سفر شغلی',
  'طبیعت و استراحت',
  'اجاره-ویلا-ییلاقی',
  'اجاره-ویلا-مبله',
  'اجاره-ویلا-کوهستانی',
  'اجاره-ویلا-شهری',
  'اجاره-ویلا-ساحلی',
  'اجاره-ویلا-روستایی',
  'اجاره-ویلا-دوبلکس',
  'اجاره-ویلا-دربستی',
  'اجاره-ویلا-دربست',
  'اجاره-ویلا-در-شمال',
  'اجاره-ویلا-داخل-شهرک',
  'اجاره-ویلا-حیاط-دار',
  'اجاره-ویلا-جکوزی-دار',
  'اجاره-ویلا-تاریخی',
  'اجاره-ویلا-با-استخر',
  'اجاره-ویلا-با-استخر-سر-پوشیده',
  'اجاره-ویلا-با-استخر-روباز',
  'اجاره-ویلا-با-استخر',
  'اجاره-ویلا-استخر-دار',
  '1',
]
